import {IS_DEV} from '@config/isDev';
import {getIsServer} from '@utils/getIsServer';
import {StateCreator, createStore} from 'zustand';
import {PersistOptions, devtools, persist} from 'zustand/middleware';
import {immer} from 'zustand/middleware/immer';

const createZustandStore = <T>(
    stateCreator: StateCreator<T, [['zustand/immer', never]], []>,
    options?: {
        persistOptions?: PersistOptions<T, Partial<T>>;
    },
) => {
    const maybePersist = (
        store: StateCreator<
            T,
            [],
            [['zustand/devtools', never], ['zustand/immer', never]]
        >,
    ) => {
        if (options?.persistOptions) {
            return persist(store, options?.persistOptions) as StateCreator<
                T,
                [],
                [['zustand/devtools', never], ['zustand/immer', never]]
            >;
        }
        return store;
    };

    return createStore(
        maybePersist(
            devtools(immer<T>(stateCreator), {
                enabled: IS_DEV && !getIsServer(),
            }),
        ),
    );
};

export default createZustandStore;
